import { Group, Text, Button, Flex, Box, Image, SimpleGrid, Paper, BackgroundImage, ScrollArea, Checkbox, Skeleton } from "@mantine/core"
import { useId } from "@mantine/hooks";
import { useDrag } from "react-dnd";
import { useTranslation } from "react-i18next";

const AIGallerySuggestionItem = ({ item, index, uuid, activeValue, onClickSuggestion }) => {
    const [{ isDragging }, dragRef] = useDrag(() => ({
        type: "image",
        item: { src: item },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    if (typeof item !== "string") {
        console.warn(`Invalid item at index ${index}:`, item);
        return null;
    }

    const key = `${uuid}_${index}`;

    const currentFilename = item ? String(item).substring(String(item).lastIndexOf('/') + 1) : '';
    const activeFilename = activeValue?.name ? activeValue.name : activeValue ? String(activeValue).substring(String(activeValue).lastIndexOf('/') + 1) : '';

    return (
        <Paper key={key} ref={dragRef} style={{ opacity: isDragging ? 0.5 : 1 }} withBorder shadow="md" radius="md" pos="relative">
            <BackgroundImage
                src={item}
                radius="sm"
                style={{
                    cursor: 'move',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}

            >
                <Checkbox checked={activeFilename == currentFilename} onClick={() => onClickSuggestion(item)} mt={4} ml={4} pos="absolute" />
                <Box mih={100} />
            </BackgroundImage>
        </Paper>
    );
};

// status (optional): 'loading' — more images are still being processed (AD-105).
export const AIGallerySuggestions = ({ aiSuggestions = [], activeValue = '', onClickSuggestion, withTitle = true, status }) => {

    const { t } = useTranslation();
    const uuid = useId();

    const aiSuggestionsArray = Array.isArray(aiSuggestions) ? aiSuggestions : [];


    return (
        <Flex direction="column">
            {
                withTitle && (
                    <Box pos="relative" pr="sm" mb="sm">
                        <Text fw={500} fz={14} c="gray" w="max-content">{t('adBuilder.aiSuggestions')}</Text>
                    </Box>
                )
            }
            
            <Box pos="relative">
                <ScrollArea h={240} pr={6}>
                    <SimpleGrid cols={3} spacing="xs">
                        {
                            aiSuggestionsArray?.map((item, index) => (
                                <AIGallerySuggestionItem
                                    key={`${uuid}_${index}`}
                                    item={item}
                                    index={index}
                                    uuid={uuid}
                                    activeValue={activeValue}
                                    onClickSuggestion={onClickSuggestion}
                                />
                            ))
                        }
                        {
                            // AD-105: remaining website images are loading async —
                            // show placeholder tiles at the end of the grid.
                            status === 'loading' && [0, 1, 2].map((i) => (
                                <Paper key={`${uuid}_skel_${i}`} withBorder radius="md">
                                    <Skeleton mih={100} radius="md" />
                                </Paper>
                            ))
                        }
                    </SimpleGrid>
                </ScrollArea>
            </Box>
        </Flex>
    );
};
